import React from 'react'
import PropTypes from 'prop-types'
import { IconSLI60Wrapper } from './IconSLI60Wrapper'

export const Icon60FileClip = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLI60Wrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 33.938 48'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M33.908,36.061 C33.903,36.152 33.885,36.240 33.855,36.326 C33.844,36.358 33.836,36.389 33.822,36.419 C33.774,36.523 33.713,36.622 33.628,36.707 L22.653,47.706 C22.561,47.798 22.451,47.872 22.329,47.923 C22.208,47.973 22.078,48.000 21.947,48.000 L1.991,48.000 C0.890,48.000 -0.005,47.102 -0.005,46.000 L-0.005,3.999 C-0.005,2.897 0.890,1.999 1.991,1.999 L8.198,1.999 C8.675,0.902 9.945,-0.000 11.969,-0.000 C13.993,-0.000 15.262,0.902 15.739,1.999 L31.925,1.999 C33.026,1.999 33.921,2.897 33.921,3.999 L33.921,35.999 C33.921,36.021 33.910,36.040 33.908,36.061 ZM22.945,44.586 L30.514,37.000 L22.945,37.000 L22.945,44.586 ZM15.960,3.999 L15.960,17.000 C15.960,19.756 13.722,21.999 10.971,21.999 C8.220,21.999 5.982,19.756 5.982,17.000 L5.982,10.999 C5.982,10.447 6.429,10.000 6.980,10.000 C7.531,10.000 7.977,10.447 7.977,10.999 L7.977,17.000 C7.977,18.654 9.320,20.000 10.971,20.000 C12.622,20.000 13.964,18.654 13.964,17.000 L13.964,3.999 L1.991,3.999 L1.991,46.000 L20.949,46.000 L20.949,35.999 C20.949,35.447 21.396,35.000 21.947,35.000 L32.000,35.000 L32.000,3.999 L15.960,3.999 Z'
        />
      </svg>
    </IconSLI60Wrapper>
  )
}

Icon60FileClip.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
